export default defineNuxtPlugin(nuxtApp => {
    const $removeAllDynamicComponents = () => {
        const components = document.getElementsByClassName("dynamic-component");
        for (let i = 0; i < components.length; i++) {
            components[i].remove();
        }
    };
    nuxtApp.provide('removeAllDynamicComponents', $removeAllDynamicComponents);
});
